import { render } from "./CurrencyRates.vue?vue&type=template&id=752dc12c"
import script from "./CurrencyRates.vue?vue&type=script&lang=js"
export * from "./CurrencyRates.vue?vue&type=script&lang=js"

import "../../assets/css/header-menu.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__